import { useBookingSync } from "@/hooks/useBookingSync"
import { getCurrentUser, fetchUserAttributes } from "aws-amplify/auth"
import { useEffect, useState } from "react"

/**
 * Provider qui initialise la synchronisation en temps réel des bookings
 * au niveau de l'application, dès que l'utilisateur est authentifié
 */
export function BookingSyncProvider({ children }: { children: React.ReactNode }) {
  const [shopId, setShopId] = useState<string>("")

  // Récupérer le shopId de l'utilisateur authentifié
  useEffect(() => {
    const initSubscription = async () => {
      try {
        const user = await getCurrentUser()
        console.log("[BookingSyncProvider] User authenticated:", user.username)

        // Le shopId est dans les custom attributes
        const attributes = await fetchUserAttributes()
        const shopIdAttr = attributes["custom:shopId"]

        if (shopIdAttr) {
          console.log("[BookingSyncProvider] Shop ID found:", shopIdAttr)
          setShopId(shopIdAttr)
        } else {
          console.warn("[BookingSyncProvider] No shopId found in user attributes")
        }
      } catch (error) {
        console.log("[BookingSyncProvider] User not authenticated:", error)
      }
    }

    initSubscription()
  }, [])

  // Initialiser la subscription AppSync
  const { isConnected, error } = useBookingSync({
    shopId,
    enabled: !!shopId,
  })

  useEffect(() => {
    if (isConnected) {
      console.log("[BookingSyncProvider] ✅ AppSync subscription connected for shop:", shopId)
    }
  }, [isConnected, shopId])

  useEffect(() => {
    if (error) {
      console.error("[BookingSyncProvider] ❌ AppSync subscription error:", error)
    }
  }, [error])

  return <>{children}</>
}
